import { asyncToGenerator as _asyncToGenerator } from '../../_virtual/_rollupPluginBabelHelpers.js';
import Cookies from '../../node_modules/universal-cookie/es6/Cookies.js';
import { getTokenStorageMethod } from './config.js';
import { TokenStorageMethod } from './constants.js';

var cookies = new Cookies();

var storeToken = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(key, token) {
    var tokenStorage;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            tokenStorage = getTokenStorageMethod();
            _context.t0 = tokenStorage;
            _context.next = _context.t0 === TokenStorageMethod.LocalStorage ? 4 : _context.t0 === TokenStorageMethod.Cookies ? 6 : 8;
            break;

          case 4:
            localStorage.setItem(key, token);
            return _context.abrupt("break", 9);

          case 6:
            cookies.set(key, token, {
              path: "/"
            });
            return _context.abrupt("break", 9);

          case 8:
            console.warn("Unknown TokenStorageMethod provided ".concat(tokenStorage));

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function storeToken(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var getToken = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(key) {
    var token;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            token = localStorage.getItem(key);

            if (token == null) {
              token = cookies.get(key);
            }

            return _context2.abrupt("return", token);

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getToken(_x3) {
    return _ref2.apply(this, arguments);
  };
}();

var clearToken = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(key) {
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            localStorage.removeItem(key);
            cookies.remove(key, {
              path: "/"
            });

          case 2:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function clearToken(_x4) {
    return _ref3.apply(this, arguments);
  };
}();

var WebTokenStoreProvider = {
  getToken: getToken,
  storeToken: storeToken,
  clearToken: clearToken
};

export { WebTokenStoreProvider };
